import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect (): void {
    setTimeout(() => {
      this.remove()
    }, 10000)
  }

  remove (): void {
    this.element.remove()
  }
}
